import React from "react"
import { graphql, Link } from "gatsby"
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"

const TextBlockWithImage = (props: any) => {

  // function to check whether or not the url is absolute
  const isUrlAbsolute = (url: string) => url?.indexOf("://") > 0 || url?.indexOf("//") === 0

  // function to generate proper link
  const generateLink = (url: string, target: string, text: string) => {

    const linkClass = "inline-block mt-8 md:mt-8 px-8 py-3 border border-transparent text-base leading-6 font-medium text-button-text bg-button-bg";

    // if relative link, use Gatsby Link
    if (isUrlAbsolute(url) === false) {
      return (
        <Link
          to={url}
          title={text}
          target={target}
          className={linkClass}
        >
          {text}
        </Link>
      )
    } else {
      // else use anchor tag
      return (
        <a
          href={url}
          title={text}
          target={target}
          className={linkClass}
        >
          {text}
        </a>
      )
    }
  }

  return (
    <div className="relative px-8">
      <div className="flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 items-center">
        <div className="w-full md:w-4/12 lg:w-6/12 flex-shrink-0 relative">
          {props.primaryButton ? (
            <Link to={props.primaryButton.href}>
              <WsrvImage
                urlParams={{
                  originURL: props.image?.url,
                  preset: EWsrvTransform.fit4x3,
                  width: props.image?.with
                }}
                imgProps={{
                  className: "rounded-lg object-cover object-center cursor-pointer"
                }}
              />
            </Link>
          ) : (
            <WsrvImage
              urlParams={{
                originURL: props.image?.url,
                preset: EWsrvTransform.fit4x3,
                width: props.image?.with
              }}
              imgProps={{
                className: "rounded-lg object-cover object-center"
              }}
            />
          )}
        </div>
        <div
          className={`w-full md:w-8/12 lg:w-6/12 mt-16 md:mt-0 ${props.imagePosition !== "right"
              ? `md:ml-12 lg:ml-16 md:order-last`
              : `md:mr-12 lg:mr-16 md:order-first`
            }`}
        >
          <div className="g:py-8 text-center md:text-left">
            {props.tagline && (
              <span className="font-bold text-primary-500 text-sm text-center md:text-left uppercase">
                {props.tagline}
              </span>
            )}
            <h2 className="font-display text-4xl font-black text-secondary-500 md:text-3xl lg:text-5xl tracking-wide text-center mt-4 lg:leading-tight md:text-left">
              {props.title}
            </h2>
            <div dangerouslySetInnerHTML={{ __html: props.content }}
              className="mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-200">
            </div>
            {props.primaryButton &&
              generateLink(
                props.primaryButton.url,
                props.openLinkInANewTab ? "_blank" : "_self",
                props.primaryButton.title
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextBlockWithImage

export const query = graphql`
fragment DrupalTextBlockWithImageContent on DrupalTextBlockWithImage {
    id
    blocktype
    backgroundImage {
      url
    }
    content
    image {
      url
      width
      height
    }
    imagePosition
    primaryButton {
      url
      title
    }
    tagline
    title
    openLinkInANewTab
}
`
